import React from 'react';

import {
  Chip,
  Stack,
  Typography,
} from '@mui/material';

import {
  GridColDef,
} from '@mui/x-data-grid';

import {
  AccountTreeOutlined as PlanIcon,
} from '@mui/icons-material';

import { FDataGrid } from '../grid';

type Props = {
  rows: any[];
  loading?: boolean;

  onTaskSelect: (row: any | null) => void;
  selectedTaskId?: any;

  canPlan?: boolean;
  onPlanTasks?: () => void;
};

export default class TaskGridPanel
  extends React.PureComponent<Props> {

  private getRowId = (row: any) =>
    row.taskplanid
    ?? row.rid
    ?? row.id;

  private money = (value: any) =>
    Number(value || 0).toLocaleString(undefined, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });

  private columns = (): GridColDef[] => [
    {
      field: 'code',
      headerName: 'Task Code',
      width: 155,
      cellClassName: 'task-cell-master',
    },
    {
      field: 'name',
      headerName: 'Task',
      minWidth: 240,
      flex: 1,
      cellClassName: 'task-cell-master',
    },
    {
      field: 'weight',
      headerName: 'Weight',
      width: 90,
      type: 'number',
      cellClassName: 'task-cell-governed',
    },
    {
      field: 'plannedamount',
      headerName: 'Budget',
      width: 165,
      align: 'right',
      headerAlign: 'right',
      renderCell: (params) => {
        const amount = Number(params.value || 0);

        return (
          <Stack
            direction="row"
            spacing={1}
            alignItems="center"
            justifyContent="flex-end"
            sx={{ width: '100%' }}
          >
            <Typography
              variant="body2"
              fontWeight={600}
            >
              {this.money(amount)}
            </Typography>

            {amount <= 0 && (
              <Chip
                size="small"
                variant="outlined"
                label="No Budget"
              />
            )}
          </Stack>
        );
      },
      cellClassName: 'task-cell-computed',
    },
  ];

  render() {
    return (
      <FDataGrid
        title="Tasks"
        subtitle="Select a Task to inspect its budget lines."
        rows={this.props.rows || []}
        columns={this.columns()}
        loading={this.props.loading}
        height={300}
        getRowId={this.getRowId}

        selectionMode="single"
        selectedRowId={this.props.selectedTaskId}

        onSelectedRowChange={(row) =>
          this.props.onTaskSelect(row)
        }

        toolbarActions={
          this.props.canPlan && this.props.onPlanTasks
            ? [
              {
                key: 'plan-tasks',
                label: 'Plan Tasks',
                icon: <PlanIcon fontSize="small" />,
                onClick: this.props.onPlanTasks,
              },
            ]
            : []
        }

        getRowClassName={(params) =>
          String(this.getRowId(params.row))
            === String(this.props.selectedTaskId ?? '')
            ? 'task-row-selected'
            : ''
        }

        sx={{
          '& .task-cell-master': {
            bgcolor: 'info.lighter',
          },

          '& .task-cell-computed': {
            bgcolor: 'success.lighter',
          },

          '& .task-cell-governed': {
            bgcolor: 'action.hover',
          },

          '& .task-row-selected': {
            boxShadow: 'inset 4px 0 0 0',
            boxShadowColor: 'primary.main',
          },
        }}
      />
    );
  }
}